import tenant from '@/services/TenantService';
import {
  Box,
  TextField,
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  DialogActions,
} from '@mui/material';
import { useState } from 'react';
import useAppStore from '@/store/app';
import { toast } from 'react-toastify';

export default function TenantProfileDialog() {
  const { setDialogForm } = useAppStore();

  const [accountData, setAccountData] = useState({
    email: '',
    firstName: '',
    lastName: '',
    mobilePhone: '',
    jobTitle: '',
    teams: [],
    role: '',
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setAccountData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const saveAccountData = async () => {
    if (
      !accountData.email ||
      !accountData.firstName ||
      !accountData.lastName ||
      !accountData.jobTitle
    ) {
      toast.error('Bitte füllen Sie alle Felder aus');
      return;
    }

    const userObject = {
      email: accountData.email,
      firstName: accountData.firstName,
      lastName: accountData.lastName,
      jobTitle: accountData.jobTitle,
    };
    try {
      const response = await tenant.post(`/user`, userObject);
      if (response.status === 204) {
        toast.success('Account wurde erfolgreich hinzugefügt');
      } else {
        toast.error('Account konnte nicht hinzugefügt werden');
      }
    } catch (error) {
      toast.error('Account konnte nicht hinzugefügt werden');
    }

    handleCloseDialog();
  };

  const handleCloseDialog = () => {
    setDialogForm(null);
  };

  return (
    <Dialog open={true} onClose={handleCloseDialog} fullWidth maxWidth="sm">
      <DialogTitle>Account hinzufügen</DialogTitle>
      <DialogContent>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            position: 'relative',
            width: '100%',
            height: '100%',
          }}
        >
          <TextField
            fullWidth
            required
            label="E-Mail"
            name="email"
            value={accountData.email}
            variant="outlined"
            margin="normal"
            onChange={handleChange}
          />
          <TextField
            required
            fullWidth
            label="Vorname"
            name="firstName"
            value={accountData.firstName}
            variant="outlined"
            margin="normal"
            onChange={handleChange}
          />
          <TextField
            required
            fullWidth
            label="Nachname"
            name="lastName"
            value={accountData.lastName}
            variant="outlined"
            margin="normal"
            onChange={handleChange}
          />
          <TextField
            required
            fullWidth
            label="Jobbezeichnung"
            name="jobTitle"
            value={accountData.jobTitle}
            variant="outlined"
            margin="normal"
            onChange={handleChange}
          />
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleCloseDialog}>Schließen</Button>
        <Button onClick={saveAccountData} variant="contained">
          Hinzufügen
        </Button>
      </DialogActions>
    </Dialog>
  );
}
